<template>
	<div>
		<loading v-if="!loaded"/>
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានគម្រោង</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* តម្រូវបំពេញ</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>ឈ្មោះគម្រោង *</label>
							<md-input type="text" v-model="project.name"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>ចំនួនឡូតិ៍សរុប *</label>
							<md-input type="number" v-model="project.total_stock"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>កំណត់ចំណាំ</label>
							<md-input type="text" v-model="project.note">
							</md-input>
						</md-field>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានសង្ខេប</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 50%;">ឈ្មោះគម្រោង</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(project.name).length > 0">{{project.name}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell style="width: 50%;">ចំនួនឡូតិ៍សរុប</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(project.total_stock).length > 0">{{project.total_stock}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>កំណត់ចំណាំ</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(project.note).length > 0">{{project.note}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="updateProject()">កែប្រែ</md-button>
			</div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: {
			datetime: Datetime
		},
		created() {
			this.getProject();

		},
		data() {
			return {
				loaded: false,
				project: {
					valid: false,
					hash: "",
					name: "",
					total_stock: "",
					note: ""
				}
			}
		},
		methods: {
			updateProject() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/project/update", {
					project: this.project
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "គម្រោងត្រូវបានធ្វើបច្ចប្បន្នភាពជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.$router.push("/projects");
					}
				})
			},
			checkValidation() {
				if (String(this.project.name).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មានបន្ថែម",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},

			getProject() {
				this.$http.get(this.config.api + "/admin/project/get/" + this.$route.params.hash).then(data => {
					// console.log(data.body.data);
					this.project = data.body.data
					this.loaded = true;
				})
			}
		}
	}
</script>
<style>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50% !important;
	}

	.file-image-wrapper {
		/* margin: 10px; */
		width: calc(100%);
		padding-top: 8px;
		padding-bottom: 5px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.file-image {
		margin-top: 21px;
		text-align: center;
		/* margin-left: 10px;
		margin-right: 10px; */
		/* min-width: calc(33.3333% - 20px) !important;
		max-width: calc(33.3333% - 20px) !important;
		flex: 0 1 calc(33.3333% - 20px) !important; */
		/* padding: 0; */
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Projects/Edit.vue